import { z } from 'zod';

type T = (
  key: string,
  params?: Record<string, string | number | Date>
) => string;

export const createBoxTypeSchema = (t: T) =>
  z.object({
    name: z.string().min(1, t('boxTypeNameRequired')),
    code: z
      .string()
      .min(1, t('boxTypeCodeRequired'))
      .max(50)
      .regex(/^[A-Z0-9-]+$/, t('boxTypeCodeFormat')),
    max_capacity: z.coerce
      .number()
      .int()
      .min(1, t('min', { min: 1 })),
    description: z.string().max(1000).optional().or(z.literal('')),
    status: z.enum(['active', 'inactive'])
  });

export const updateBoxTypeSchema = createBoxTypeSchema;

export type CreateBoxTypeFormValues = z.infer<
  ReturnType<typeof createBoxTypeSchema>
>;
export type UpdateBoxTypeFormValues = z.infer<
  ReturnType<typeof updateBoxTypeSchema>
>;
